import React, { useState } from 'react';

import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import { Dropdown } from 'components/Forms';
import { clearTasksSelection } from 'store/clinicalLogger/reducer';
import { TaskStatus } from 'constants/enums';
import { useAppSelector } from 'hooks';

import BulkUpdateTasksStatusModal from './BulkUpdateTasksStatusModal';
import BulkAssignTasksModal from './BulkAssignTasksModal';

type IBulkAction = 'updateStatusToOnHold' | 'updateStatusToArchived' | 'updateAssignees';

interface IBulkTaskActionsProps {
  get: () => void;
}

const BulkTaskActions = ({ get }: IBulkTaskActionsProps) => {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const selectedTasks = useAppSelector((state) => state.clinicalLogger.tasks);

  const bulkActions: ISelectOption[] = [
    { label: formatMessage({ id: 'bulkArchiveKey' }), value: 'updateStatusToArchived' },
    { label: formatMessage({ id: 'bulkOnHoldKey' }), value: 'updateStatusToOnHold' },
    { label: formatMessage({ id: 'bulkAssignTasksKey' }), value: 'updateAssignees' },
    {
      label: formatMessage({ id: 'bulkResumeTasksKey' }),
      value: 'updateStatusToUpcoming',
      disabled: selectedTasks.some((task) => task.status !== parseInt(TaskStatus.ON_HOLD))
    }
  ];
  const [modal, setModal] = useState('');

  const handleClose = (refresh?: boolean) => {
    setModal('');
    if (refresh) {
      get();
      dispatch(clearTasksSelection());
    }
  };

  const getStatus = () => {
    switch (modal) {
      case 'updateStatusToArchived':
        return TaskStatus.ARCHIVED;
      case 'updateStatusToOnHold':
        return TaskStatus.ON_HOLD;
      default:
        return TaskStatus.ACTIVE;
    }
  };

  return (
    <>
      {selectedTasks.length > 0 && (
        <Dropdown
          options={bulkActions}
          variant="transparent"
          minWidth={150}
          maxWidth={200}
          fitContent={true}
          placeholder={formatMessage({ id: 'bulkActionsKey' })}
          className="ms-auto me-2"
          isSearchable={false}
          value={null}
          onChange={(option: ISelectOption) => setModal(option.value as IBulkAction)}
          dataTestId="bulkPatientActionDropdown"
        />
      )}
      {modal === 'updateAssignees' && <BulkAssignTasksModal handleClose={handleClose} />}
      {(modal === 'updateStatusToOnHold' ||
        modal === 'updateStatusToArchived' ||
        modal === 'updateStatusToUpcoming') && (
        <BulkUpdateTasksStatusModal handleClose={handleClose} status={getStatus()} />
      )}
    </>
  );
};

export default BulkTaskActions;
